import { useTranslation } from 'react-i18next';
import { DOCUMENTATION_VIEW_MODEL} from '../../Model/Models';
import { useState } from 'react';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack
 */
export const CommonDocumentationApp = ( ) => {
    const { t } = useTranslation();
    const [subView, setSubView] = useState(DOCUMENTATION_VIEW_MODEL.DOCUMENTATION);

    /**
     * Updates the active subview of the documentation module.
     * @param {string} value - New subview value.
     */
    const handleSubViewChange = (value) => {
        setSubView(value);
    };

    /**
     * Checks if there is an active contractor or supplier in session storage.
     * @returns {boolean} True if a contractor or supplier ID exists in sessionStorage.
     */
    const isActiveContractorSupplier = () => {
        const contractorId = sessionStorage.getItem('contractorId');
        const supplierId = sessionStorage.getItem('providerId');

        if(!contractorId && !supplierId)
            return false;

        return true;
    }

    return {
        t,
        subView,
        handleSubViewChange,
        isActiveContractorSupplier
    };
};
